module.exports = __webpack_public_path__ + "img/0Q3A5108-23_P_L_WoodMatted_MockedUp.ad8914aa.jpg";